import { Box, LinearProgress } from "@mui/material";

export const LoadSlider = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      gap={3}
    >
      <Box width={{xs: 200, sm: 250, md: 350}}>
        <LinearProgress color="secondary" sx={{ borderRadius: 15 }} />
      </Box>
    </Box>
  );
};
